import { Route, Routes } from "react-router-dom";
import "./index.css";
import CoinifyPage from "./page/Coinify";
import Nav from "./ui/nav";
import DecomposePage from "./page/Decompose";
import HomePage from "./page/HomePage";
import TransmutePage from "./page/TransmutePage";
import WoodcuttingPage from "./page/WoodcuttingPage";
import CraftingPage from "./page/CraftingPage";
import BlogPage from "./page/Blog";

export function App() {
  return (
    <div>
      <Nav />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/coinify" element={<CoinifyPage />} />
        <Route path="/decompose" element={<DecomposePage />} />
        <Route path="/transmute" element={<TransmutePage />} />
        <Route path="/woodcutting" element={<WoodcuttingPage />} />
        <Route path="/crafting" element={<CraftingPage />} />
        <Route path="/blog" element={<BlogPage />} />
      </Routes>
    </div>
  );
}

export default App;
